var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatReversoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 21.3333C6.28889 21.3333 5.97222 21.2056 5.71667 20.95C5.46111 20.6944 5.33333 20.3778 5.33333 20V17.3333H22.6667V5.33333H25.3333C25.7111 5.33333 26.0278 5.46111 26.2833 5.71667C26.5389 5.97222 26.6667 6.28889 26.6667 6.66667V23.4333C26.6667 24.0333 26.3944 24.45 25.85 24.6833C25.3056 24.9167 24.8222 24.8222 24.4 24.4L21.3333 21.3333H6.66667ZM5.33333 14.6667L2.26667 17.7333C1.84444 18.1556 1.36111 18.25 0.816667 18.0167C0.272222 17.7833 0 17.3667 0 16.7667V1.33333C0 0.955556 0.127778 0.638889 0.383333 0.383333C0.638889 0.127778 0.955556 0 1.33333 0H18.6667C19.0444 0 19.3611 0.127778 19.6167 0.383333C19.8722 0.638889 20 0.955556 20 1.33333V13.3333C20 13.7111 19.8722 14.0278 19.6167 14.2833C19.3611 14.5389 19.0444 14.6667 18.6667 14.6667H5.33333ZM17.3333 12V2.66667H2.66667V12H17.3333Z",
    fill: "#FFAF49"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatReversoIcon);
export default __webpack_public_path__ + "static/media/chat-reverso-icon.2196f9eb.svg";
export { ForwardRef as ReactComponent };